import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    Update,
    GetById
} from "adminApi/AboutUsApi/AboutUs.js";
import { validateForm } from "utils/validation";
import { AboutUsRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import fields from "../json/AboutUsField.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import EditAboutUsForm from "./Components/EditAboutUsForm";

const EditAboutUs = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { formdata } = fields;

    // Initialize form values
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, handleArrayChange, setValues, setErrors, handleFileChange } = useFormChange(initialValues, AboutUsRules);

    // Fetch existing data by ID
    const { loading: loadingFetch } = useFetchFormDataById(id, formdata, GetById, setValues);

    // Form submit hook
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            const formData = new FormData();
            Object.entries(formValues).forEach(([key, val]) => {
                if (key === "story_image") {
                    // Handle single file upload
                    if (val && val instanceof File) {
                        formData.append(key, val);
                    }
                } else if (key === "stats" || key === "values_list") {
                    formData.append(key, typeof val === 'string' ? val : JSON.stringify(val || []));
                } else {
                    if (val !== undefined && val !== null && !(val instanceof File)) {
                        formData.append(key, val);
                    }
                }
            });
            return await Update({ id, data: formData });
        },
        (vals) => {
            const err = validateForm(vals, AboutUsRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "About Us updated successfully"
    );

    console.log("values", values)
    return (
        <>
            {(loadingFetch || loadingSubmit) && <Spinner isSpinner={true} />}
            <EditAboutUsForm
                fields={formdata}
                values={values}
                setValues={setValues}
                errors={errors}
                handleChange={handleChange}
                handleArrayChange={handleArrayChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Edit About Us"
                handleFileChange={handleFileChange}
                imagePreview={values.story_imagePreview || values.story_image}
            />
        </>
    );
};

export default EditAboutUs;
